import m from "mithril";
import DateUtilities from "../../shared/utilities/date_utilities";
import i18n from "../../shared/i18n/i18n";
import ModalManager from "../../shared/modal";
import Modal_Assessment_History_Form from "../../admin/enrolment/modal_assessment_history_form";

function viewAssessmentFormResponse(record) {
    ModalManager.open(record.unitName, [], Modal_Assessment_History_Form, {
        record: record,
    });
}

const Modal_Unit_Assessment_History = {
    oninit(vnode) {
        vnode.state.expanded = false;
    },
    view: function (vnode) {
        return [
            m(".form-section", [
                vnode.attrs.history && vnode.attrs.history.length > 0 ? [
                    m(".table-wrapper flex-auto", [
                        m("table.full-width fixed-table ellipsis", [
                            m("thead",
                                m("tr", [
                                    m("th", { style: "width: 20%;" }, i18n.t("assessment_date")),
                                    m("th", { style: "width: 15%;" }, i18n.t("assessment_name")),
                                    m("th", { style: "width: 15%;" }, i18n.t("assessor")),
                                    m("th", { style: "width: 15%;" }, i18n.t("result")),
                                    m("th", { style: "width: 35%;" }, i18n.t("feedback"))
                                ])
                            ),
                            m("tbody", vnode.attrs.history.map(function (record, index) {
                                return [
                                    m("tr", [
                                        m("td", {onclick: () => viewAssessmentFormResponse(record)},
                                            DateUtilities.getFormattedDateFromUTC(record.creationDate)),
                                        m("td", {onclick: () => viewAssessmentFormResponse(record)}, record.unitName),
                                        m("td", {onclick: () => viewAssessmentFormResponse(record)}, record.assessorName),
                                        m("td", {onclick: () => viewAssessmentFormResponse(record)},
                                            record.isPassed ?  i18n.t("passed") : i18n.t("not_yet_competent")),
                                        m("td", {
                                            class: vnode.state.expanded ? "td-expanded" : "td-truncated",
                                            onclick: () => vnode.state.expanded = !vnode.state.expanded
                                        }, i18n.t(record.assessorFeedback))
                                    ])
                                ];
                            }))
                        ])
                    ])
                ] : m(".text-gray padding", i18n.t("no_records"))
            ])
        ];
    }
};
export default Modal_Unit_Assessment_History;
